import React from "react";
import { Form, Icon, Input, Button, Checkbox } from "antd";
import { login } from "../../redux/actions/profileAction";
import { connect } from "react-redux";
import { withRouter, Redirect } from "react-router-dom";

class NormalLoginForm extends React.Component {
  state = {
    size: "large",
    email: "",
    password: ""
  };

  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        console.log("Received values of form: ", values);
        this.props.login(values);
      }
    });
  };

  handleChange = e => {
    this.setState(
      {
        [e.target.name]: e.target.value
      }
      // console.log(this.state)
    );
  };

  render() {
    if (this.props.isAuthenticated) {
      return <Redirect to="/dashboard" />;
    } else {
      const size = this.state.size;
      const { getFieldDecorator } = this.props.form;
      return (
        <Form onSubmit={this.handleSubmit} className="login-form">
          <Form.Item>
            {getFieldDecorator("email", {
              rules: [{ required: true, message: "Please input your email!" }]
            })(
              <Input
                prefix={
                  <Icon type="mail" style={{ color: "rgba(0,0,0,.25)" }} />
                }
                placeholder="Email"
                name="email"
                onChange={this.handleChange}
              />
            )}
          </Form.Item>
          <Form.Item>
            {getFieldDecorator("password", {
              rules: [
                { required: true, message: "Please input your Password!" }
              ]
            })(
              <Input
                prefix={
                  <Icon type="lock" style={{ color: "rgba(0,0,0,.25)" }} />
                }
                type="password"
                placeholder="Password"
                name="password"
                onChange={this.handleChange}
              />
            )}
          </Form.Item>
          <Form.Item>
            {getFieldDecorator("remember", {
              valuePropName: "checked",
              initialValue: true
            })(<Checkbox>Remember me</Checkbox>)}
            <a className="login-form-forgot" href="login">
              Forgot password
            </a>
            <Button
              type="primary"
              htmlType="submit"
              className="login-form-button"
              shape="round"
              value="large"
              size={size}
            >
              Log in
            </Button>
          </Form.Item>
        </Form>
      );
    }
  }
}

const WrappedNormalLoginForm = Form.create({ name: "normal_login" })(
  NormalLoginForm
);

const mapStateToProps = store => ({
  isAuthenticated: store.profile.isAuthenticated
});

export default connect(
  mapStateToProps,
  { login }
)(withRouter(WrappedNormalLoginForm));
